import filesMutations from "./mutations.js";
import filesActions from "./actions.js";
import filesGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            currentPathFolderInfo: {},
        };
    },
    mutations: filesMutations,
    actions: filesActions,
    getters: filesGetters,
};